import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, mergeProps as _mergeProps, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "grid grid-auto-cols grid-rows-auto auto-rows-min auto-cols-min gap-y-2 gap-x-6" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg font-semibold col-span-2" }, " Change password ", -1);
const _hoisted_3 = { class: "flex flex-col col-span-1 lg:col-span-1" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("label", null, "Current password", -1);
const _hoisted_5 = { class: "error-text" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("label", null, "New password", -1);
const _hoisted_7 = { class: "error-text" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("label", null, "Confirm password", -1);
const _hoisted_9 = { class: "error-text" };
import { useForm } from 'vee-validate';
import * as yup from 'yup';
import Button from 'primevue/button';
import Password from 'primevue/password';
import { useFetch } from '@apparatix/composables';
import PasswordRequirementsFeedback from '@apparatix/library/PasswordRequirementsFeedback.vue';
import FormTextGroup from '@apparatix/library/FormTextGroup.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ChangePassword',
    emits: ["update:loading"],
    setup(__props, { emit: __emit }) {
        const { put } = useFetch();
        const { defineField, errors, handleSubmit, meta, setFieldError } = useForm({
            validationSchema: yup.object({
                currentPassword: yup.string()
                    .required('Current password is required'),
                password: yup.string()
                    .min(8)
                    .required('New password is required')
                    .matches(/^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/, { message: 'Password should contain at lease one of each: uppercase, lowercase, number, special character' }),
                confirmPassword: yup.string()
                    .oneOf([yup.ref('password'), null], 'Passwords do not match'),
            }),
        });
        const [currentPassword, currentPasswordAttrs] = defineField('currentPassword');
        const [password, passwordAttrs] = defineField('password');
        const [confirmPassword, confirmPasswordAttrs] = defineField('confirmPassword');
        const emit = __emit;
        const updatePassword = async (values) => {
            const payload = {
                password: values.password,
                // eslint-disable-next-line camelcase
                current_password: values.currentPassword,
                // eslint-disable-next-line camelcase
                password_confirmation: values.confirmPassword,
            };
            emit('update:loading', true);
            const response = await put('/user/password', payload);
            if (response?.errors) {
                const errs = response.errors;
                Object.keys(errs).forEach(key => {
                    if (Object.hasOwn(errs, key)) {
                        if (key === 'password') {
                            setFieldError('password', errs[key]);
                        }
                        if (key === 'current_password') {
                            setFieldError('currentPassword', errs[key]);
                        }
                        if (key === 'password_confirmation') {
                            setFieldError('confirmPassword', errs[key]);
                        }
                    }
                });
            }
            console.log('update res', response);
            emit('update:loading', false);
        };
        const onSubmit = handleSubmit((values) => updatePassword(values));
        const passwordRules = [
            { regex: new RegExp(/^.{8,}$/), message: 'At least 8 characters' },
            { regex: new RegExp(/[A-Z]/), message: 'At least 1 uppercase letter' },
            { regex: new RegExp(/\d/), message: 'At least 1 number' },
            { regex: new RegExp(/[!@#$%^&*]/), message: 'At least 1 special character (!@#$%^&*)' },
        ];
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("form", {
                onSubmit: _cache[3] || (_cache[3] =
                    //@ts-ignore
                    (...args) => (_unref(onSubmit) && _unref(onSubmit)(...args)))
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _hoisted_2,
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(FormTextGroup, null, {
                            default: _withCtx(() => [
                                _hoisted_4,
                                _createVNode(_unref(Password), _mergeProps({
                                    modelValue: _unref(currentPassword),
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_isRef(currentPassword) ? (currentPassword).value = $event : null))
                                }, _unref(currentPasswordAttrs), {
                                    "aria-label": "Current password",
                                    feedback: false,
                                    invalid: !!_unref(errors).currentPassword,
                                    "toggle-mask": ""
                                }), null, 16, ["modelValue", "invalid"]),
                                _createElementVNode("small", _hoisted_5, _toDisplayString(_unref(errors).currentPassword), 1)
                            ]),
                            _: 1
                        }),
                        _createVNode(FormTextGroup, null, {
                            default: _withCtx(() => [
                                _hoisted_6,
                                _createVNode(_unref(Password), _mergeProps({
                                    modelValue: _unref(password),
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (_isRef(password) ? (password).value = $event : null))
                                }, _unref(passwordAttrs), {
                                    invalid: !!_unref(errors).password,
                                    "aria-label": "New password",
                                    feedback: false,
                                    "toggle-mask": ""
                                }), null, 16, ["modelValue", "invalid"]),
                                _createElementVNode("small", _hoisted_7, _toDisplayString(_unref(errors).password), 1)
                            ]),
                            _: 1
                        }),
                        _createVNode(FormTextGroup, null, {
                            default: _withCtx(() => [
                                _hoisted_8,
                                _createVNode(_unref(Password), _mergeProps({
                                    modelValue: _unref(confirmPassword),
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (_isRef(confirmPassword) ? (confirmPassword).value = $event : null))
                                }, _unref(confirmPasswordAttrs), {
                                    invalid: !!_unref(errors).confirmPassword,
                                    "aria-label": "Confirm password",
                                    feedback: false,
                                    "toggle-mask": ""
                                }), null, 16, ["modelValue", "invalid"]),
                                _createElementVNode("small", _hoisted_9, _toDisplayString(_unref(errors).confirmPassword), 1)
                            ]),
                            _: 1
                        }),
                        _createElementVNode("div", null, [
                            _createVNode(_unref(Button), {
                                class: "mt-2",
                                type: "submit",
                                label: "Reset password",
                                disabled: !_unref(meta).valid
                            }, null, 8, ["disabled"])
                        ])
                    ]),
                    (_unref(meta).touched)
                        ? (_openBlock(), _createBlock(PasswordRequirementsFeedback, {
                            key: 0,
                            class: "col-span-2 lg:col-span-1",
                            password: _unref(password),
                            rules: passwordRules,
                            "show-strength": ""
                        }, null, 8, ["password"]))
                        : _createCommentVNode("", true)
                ])
            ], 32));
        };
    }
});
